var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaddex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KADDEX",
    transform: "translate(-971 -6639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaddex-2",
    "data-name": "Kaddex",
    transform: "translate(971 6639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Down",
    transform: "translate(19.171 47.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_down_yellow",
    d: "M453.163,674.6a1.075,1.075,0,0,0-.944-.6h-28.35a1.079,1.079,0,0,0-1.075,1.082v5.088a.473.473,0,0,0,.471.474h32.888Z",
    transform: "translate(-422.794 -674.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_dx",
    transform: "translate(29.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_dx_blu",
    d: "M542.431,239l26.152,53.3a.478.478,0,0,1-.028.445.472.472,0,0,1-.382.225h-7.041l-20.611-41.715",
    transform: "translate(-538.601 -239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_dx_gradient",
    d: "M526.367,239l7.787,15.83-3.962,8-7.546-15.294a1.1,1.1,0,0,1,0-.949Z",
    transform: "translate(-522.538 -239)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_sx"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo_sx_pink",
    d: "M271.522,239.628a1.075,1.075,0,0,1,.943-.6h7.117l-.061.123-3.891,7.856L253.02,292.688a.472.472,0,0,1-.41.256h-5.764a1.074,1.074,0,0,1-.9-.52,1.089,1.089,0,0,1-.045-1.042Z",
    transform: "translate(-245.792 -239.03)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaddex);
export default __webpack_public_path__ + "static/media/kaddex.120816ec7efc58132ba1fbae0ed9c72e.svg";
export { ForwardRef as ReactComponent };